import STATIC from './static'
import API from '@/api'
import request from '@/utils/request'

import Pagination from '@/components/Pagination'
import JR_Table from '@/components/JR_Table'
import JR_PageHeader from '@/components/JR_PageHeader'

export default {
  install: (Vue, options) => {
    Vue.prototype.$http = request
    Vue.prototype.$api = API
    Vue.prototype.$static = STATIC

    Vue.component('jr-pagination', Pagination)
    Vue.component('jr-table', JR_Table)
    Vue.component('jr-page-header', JR_PageHeader)
  }
}
